import classNames from "classnames";
import { SelectV2 } from "PFComponents/select_v2";
import { Id, Option } from "PFTypes";

import { PillProps } from "../../pill";
import { DoubleSectionPill, DoubleSectionPillProps } from "../double_section_pill";
import css from "./select_pill.module.scss";

type SelectPillProps<T> = Omit<DoubleSectionPillProps, "rightContent" | "rightContentClassName"> & {
  value?: Id;
  options: Option<T>[];
  disabled?: boolean;
  onAttributeChange?: (newAttribute: T) => void;
} & Pick<PillProps, "small">;

// eslint-disable-next-line comma-spacing
export const SelectPill = <T,>({
  value,
  options,
  onAttributeChange,
  small,
  disabled,
  ...rest
}: SelectPillProps<T>) => (
  <DoubleSectionPill
    small={small}
    {...rest}
    rightContent={
      <SelectV2
        variant="table"
        options={options}
        value={value}
        disabled={disabled}
        onChange={(option) => onAttributeChange?.((option as Option<T>).original)}
        className={classNames(css.customSelect, { [css.smallCustomSelect]: small })}
      />
    }
    rightContentClassName={css.rightContentRoot}
  />
);
